export const MARK_SUGGESTION = 'suggestion';
export const KEY_SUGGESTION_ID = 'suggestionId';
